<template>
    <div class="small-card-container">
        <div class="d-flex align-items-center mb-sm-5 mb-lg-0">
            <i class="fs-4 far fa-chart-bar"></i>
            <!-- <i class="fs-lg" :class="data.icon"></i> -->
            <div class="ms-3">
                <h6 class="heading-xxs mb-1">
                    {{ data.title }}
                </h6>
                <p class="mb-0 fs-sm">
                    {{ data.subtitle }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SmallC",
    props: {
		data: {
			type: Object
		}
	},
    setup() {
        return {};
    },
}
</script>
